import React from 'react';
import { CartCardLabel as CartCardLabel$1 } from './CartCardLabel.styles.js';

var CartCardLabel = function CartCardLabel(_a) {
  var background = _a.background,
      label = _a.label;
  return React.createElement(CartCardLabel$1, {
    background: background
  }, label);
};

export { CartCardLabel };